import React from 'react';

export const Invoices = () => (
  <div className="pageSection invoicesPage">
    <section className="invoicesComingSoon" aria-labelledby="invoices-heading">
      <div className="invoicesIcon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M6 3h9l4 4v14H6Z"/><path d="M15 3v5h4M9 12h7M9 16h7"/></svg>
      </div>
      <span className="invoicesEyebrow">Coming soon</span>
      <h2 id="invoices-heading">Invoices are on the way</h2>
      <p>We’re building a convenient place to review and manage your invoices directly from the client portal.</p>
    </section>
  </div>
);
